import React from 'react';
import { LinkListItem } from '../../../../../types/globalSettingsType';
import { FooterLink } from '../FooterLink/FooterLink';
import * as S from './FooterAccordion.styles';

interface FooterAccordionProps {
  header?: string;
  links?: LinkListItem[];
}

const FooterAccordion: React.FC<FooterAccordionProps> = ({ header, links }) => {
  if (!links?.length) return null;

  return (
    <S.StyledAccordion label={header ?? ''} size="large">
      <S.LinkList>
        {links.map((link) => (
          <FooterLink key={`${link.title}-${link.key}`} link={link} />
        ))}
      </S.LinkList>
    </S.StyledAccordion>
  );
};

export default FooterAccordion;
